// extracted by mini-css-extract-plugin
module.exports = {"quizStartModal":"_1EzrVE","text":"_1AZ8vK","buttonContainer":"ZazHoZ"};